
/** live config */
var data = {
  production: true,
  ismUrl: 'https://api.isocietymanager.com',
  vmsUrl: 'https://vms-api.isocietymanager.com',
  paymentUrl: 'https://pay-api.isocietymanager.com',
  meterUrl: 'https://meter-api.isocietymanager.com',
  surveyUrl: 'https://survey-api.isocietymanager.com/api',
  marketplaceUrl: 'https://market-api.isocietymanager.com/',
  formUrl: 'https://form-api.isocietymanager.com',
  notifyUrl : 'https://notify.isocietymanager.com',
  drsServerUrl : 'https://drs-api.isocietymanager.com/',
  allowRole:['member','resident','tenant'],
  oneSignalAppId : '21c23c69-e39f-476f-9c1e-a88676ede1df',
  oneSignalAppName : 'ism_resident',
  
  //android
  oneSignalGoogleId : '53760756113',
  appName : 'ism_res_android',
  playStore : 'https://play.google.com/store/apps/details?id=com.sumasamu.iSocietyManager',

  //ios
  // oneSignalGoogleId : '',
  // appName : 'ism_res_ios',
  // playStore : 'https://apps.apple.com/in/app/isocietymanager/id1139733523',
  
  dispAppName : 'iSocietyManager',
  AppVersionCode : '450',
  baseUrl:'https://isocietymanager.com',
  ismBaseUrl:'https://isocietymanager.com',
  icon: '',
  subDomain:'isocietymanager',
  targetUrl: 'https://isocietymanager.com/apps/test?app_name=isocietymanager',
  constant: {'APP':1, 'WEB':2 },
  runAs: 2,
  
  switchToWeb: 0,
  debug: 1,
  terms_url: 'https://isocietymanager.com/terms-conditions.html',
  languages: {"English":'en', "Khmer(ភាសាខ្មែរ)":'km', "Chinese(脊椎)" :'zh', "Vietnamese":'vi'},
  langPattern: /en|zh|vi|km|/,
  officeName: "Factech Automation Solutions Private Limited",
  officeAddress: "91Springboard, C2, Sector 1, Sector 1, Noida, Uttar Pradesh 201301",
  environment: "live" 
  };
  export const environment = data;

/** Test/Local Config*/
// const HOST = 'https://test.isocietymanager.com'
// // const HOST = 'http://localhost'
// var data = {
//   production: false,
//   ismUrl: HOST + '/isocietymanager/api',
//   vmsUrl: HOST + '/vms.isocietymanager/public',
//   paymentUrl: HOST + '/payment/public/',
//   meterUrl: HOST + '/meter/public',
//   marketplaceUrl: HOST + '/market/public',
//   surveyUrl: HOST + '/survey/public/api',
//   formUrl: HOST + '/form/public',
//   notifyUrl :HOST + '/notify/public',
//   allowRole: ['member', 'resident', 'tenant'],
//   oneSignalAppId: '21c23c69-e39f-476f-9c1e-a88676ede1df',
//   oneSignalGoogleId: '53760756113',
//   oneSignalAppName: 'ism_resident',
//   appName: 'ism_res_android',
//   dispAppName: 'iSocietyManager',
//   AppVersionCode: '399',
//   baseUrl: HOST + '/isocietymanager.com',
//   ismBaseUrl: HOST + '/isocietymanager.com',
//   playStore: 'https://play.google.com/store/apps/details?id=com.sumasamu.iSocietyManager',
//   icon: '',
//   subDomain: 'isocietymanager',
//   targetUrl: HOST + '/isocietymanager.com/apps/test?app_name=isocietymanager',
//   constant: { 'APP': 1, 'WEB': 2 },
//   runAs: 1,
//   switchToWeb: 0,
//   debug: 0,
//   terms_url: HOST + '/isocietymanager.com/terms-conditions.html',
//   languages: { "English": 'en', "Khmer(ភាសាខ្មែរ)": 'km', "Chinese(脊椎)": 'zh', "Vietnamese": 'vi' },
//   langPattern: /en|zh|vi|km|/,
//   officeName: "Factech Automation Solutions Private Limited",
//   officeAddress: "91Springboard, C2, Sector 1, Sector 1, Noida, Uttar Pradesh 201301",
//   drsServerUrl: HOST + '/drs.isocietymanager/public',
// }
// export const environment = data;




// WEBPACK FOOTER //
// ./src/environments/environment.ts